import type { Household, User } from '../types';
import { getPersonalHouseholdId } from './householdUtils';
import { isNutritionConsultant } from './userType';

export function isGuidedClientHousehold(
    household: Pick<Household, 'isGuidedClientHousehold' | 'guidedClientId'>,
): boolean {
    return household.isGuidedClientHousehold === true || !!household.guidedClientId;
}

export function canAccessGuidedClientsAdmin(user: Pick<User, 'role' | 'userType'>): boolean {
    return user.role === 'superuser' || isNutritionConsultant(user);
}

export function getConsultantSwitchableHouseholds(
    user: Pick<User, 'uid' | 'role' | 'userType'>,
    households: Household[],
): Household[] {
    if (!canAccessGuidedClientsAdmin(user)) {
        return households;
    }
    return households.filter((household) => !isGuidedClientHousehold(household));
}

export function resolveConsultantActiveHouseholdId(
    user: Pick<User, 'uid' | 'role' | 'userType' | 'activeHouseholdId' | 'households'>,
    households: Household[],
    clientContextHouseholdId?: string | null,
): string {
    if (clientContextHouseholdId) {
        return clientContextHouseholdId;
    }

    const switchable = getConsultantSwitchableHouseholds(user, households);
    const switchableIds = switchable.map((household) => household.id);
    const personalId = getPersonalHouseholdId(user.uid);

    if (user.activeHouseholdId && switchableIds.includes(user.activeHouseholdId)) {
        return user.activeHouseholdId;
    }
    if (switchableIds.includes(personalId)) {
        return personalId;
    }
    return switchableIds[0] || personalId;
}
